export default "__VITE_ASSET__a31a2b78__"